import { uniqueId } from 'lodash'

export const defaultInfoSection = (variant = 'testimonial') => ({
  '@type': '@builder.io/sdk:Element',
  '@version': 2,
  id: uniqueId(),
  class: 'tile',
  component: {
    name: 'Flex',
    options: {
      isColumn: true,
      reverseInMobile: false,
      alignItems: 'strech',
      justifyContent: 'center',
      gap: 24,
    },
  },
  children: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      id: uniqueId(),
      class: 'tile-image',
      component: {
        name: 'Image',
        options: {
          image:
            'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          lazy: false,
          fitContent: true,
          aspectRatio: 0.7041,
          lockAspectRatio: false,
        },
      },
      responsiveStyles: {
        large: {
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          flexShrink: '0',
          boxSizing: 'border-box',
          minHeight: '20px',
          minWidth: '20px',
          overflow: 'hidden',
          objectFit: 'cover',
        },
      },
    },
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      id: uniqueId(),
      component: {
        name: 'Text',
        options: {
          text: variant.includes('testimonial')
            ? 'Type the testimonial...'
            : 'Type the program title',
          style: 'Body MD',
        },
      },
      responsiveStyles: {
        large: {
          color: 'rgba(22, 24, 25, 1)',
          textAlign: variant === 'testimonialCircle' ? 'center' : 'left',
          fontWeight: variant.includes('testimonial') ? '400' : '500',
        },
      },
    },
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      id: uniqueId(),
      component: {
        name: 'Text',
        options: {
          text: variant.includes('testimonial')
            ? '<p>— Type the name... </p>'
            : '<p>Type the program description...</p>',
          style: 'Body MD',
        },
      },
      responsiveStyles: {
        large: {
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          flexShrink: '0',
          boxSizing: 'border-box',
          height: 'auto',
          textAlign: variant === 'testimonialCircle' ? 'center' : 'left',
          color: 'rgba(112, 111, 115, 1)',
          fontWeight: variant.includes('testimonial') ? '400' : '500',
        },
      },
    },
  ],
  responsiveStyles: {
    large: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      flexShrink: '0',
      boxSizing: 'border-box',
      aliginItems: 'center',
      gap: variant === 'program' ? '8px' : '20px',
    },
  },
})
